var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_244_33396)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 8,
    height: 16,
    fill: "#E3283E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H8V0H0V16Z",
    fill: "#128A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.381 7.46667C10.381 7.09848 10.0825 6.80001 9.71436 6.80001C9.34617 6.80001 9.04769 7.09848 9.04769 7.46667H10.381ZM10.5371 9.89941C10.8609 10.0747 11.2655 9.95443 11.4408 9.63066C11.6162 9.3069 11.4958 8.90231 11.1721 8.72697L10.5371 9.89941ZM12.8882 8.69274C12.5721 8.88146 12.4688 9.29074 12.6575 9.60688C12.8462 9.92303 13.2555 10.0263 13.5716 9.83761L12.8882 8.69274ZM14.9525 7.46667C14.9525 7.09848 14.654 6.80001 14.2858 6.80001C13.9176 6.80001 13.6191 7.09848 13.6191 7.46667H14.9525ZM9.04769 7.46667C9.04769 8.52569 9.6638 9.42646 10.5371 9.89941L11.1721 8.72697C10.6819 8.4615 10.381 7.98491 10.381 7.46667H9.04769ZM13.5716 9.83761C14.3867 9.35109 14.9525 8.48093 14.9525 7.46667H13.6191C13.6191 7.96367 13.3431 8.42125 12.8882 8.69274L13.5716 9.83761Z",
    fill: "#8C9157"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.53331C12.6312 8.53331 13.1429 7.81697 13.1429 6.93331C13.1429 6.04966 12.6312 5.33331 12 5.33331C11.3689 5.33331 10.8572 6.04966 10.8572 6.93331C10.8572 7.81697 11.3689 8.53331 12 8.53331Z",
    fill: "#C59262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/MX.0a538f260553ffb9f048e54c47997860.svg";
export { ForwardRef as ReactComponent };